import { render, staticRenderFns } from "./MyFocus.vue?vue&type=template&id=ca0f32c4&scoped=true&"
import script from "./MyFocus.vue?vue&type=script&lang=js&"
export * from "./MyFocus.vue?vue&type=script&lang=js&"
import style0 from "./MyFocus.vue?vue&type=style&index=0&id=ca0f32c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0f32c4",
  null
  
)

export default component.exports